export const EXPECTED_ROLE = "waiter";
